<template>
  <section class="printQueueTriggerWrapper">
    <div v-b-tooltip.hover :title="`Print Queue: Add ${level == 'item' ? 'This Item' : 'Whole Order'}`" class="addIt" :class="{alreadyExists: lastAddedDate}" :style="{backgroundColor: level == 'item' ? '#badc58' : '#6ab04c'}" @click="addToItemList" v-if="shouldBeActive">
       <span>+
       </span>
       <b-spinner label="Spinning" small variant="dark" v-if="inProgress" class="inProgress"></b-spinner>
       <span class="added" v-if="showAdded">Added</span>
       <span class="alreadyAdded" v-if="lastAddedDate">Already added: {{ moment(lastAddedDate).format('DD-MM-YYYY, h:mm a') }}</span>
    </div>
    <div v-else class="inactiveAddIt" :class="level == 'item' ? 'item-trigger' : 'order-trigger'"  v-b-tooltip.hover :title="!shouldBeActive ? 'Order is On Hold' : 'Please check statuses'" @click="showCantAddNotification" >
        <span>+</span>
    </div>
  </section>
</template>

<script>
import ItemListService from '../../services/item-list.service'
import EventBus from '../../EventBus';

  export default {

     props: {
       orderId:{
         type: Number,
         default: null
       },
       id: {
         type: Number,
         default: null
       },
       level: {
         type: String,
         default: ''
       },
       alreadyThere: {
         type: String,
         default: 'no'
       },
       itemInList: {
         type: Array,
         default: () => ([])
       },
       shouldBeActive:{
         type: Boolean,
         default: true
       }
     },
     data(){
       return {
         showAdded: false,
         inProgress:false
       }
     },
     methods: {
       async addToItemList(){
         try{
            let data = {
              orderId: this.orderId,
              id: this.id,
              level: this.level
            }
            this.inProgress = true;

            const result = await ItemListService.addToItemList(data)

            this.inProgress = false;

            this.showAdded = true;
            setTimeout(() =>{
              this.showAdded = false;
            }, 3000)

            EventBus.$emit('notify-others-items-in-list-added')

            EventBus.$emit('item-in-list-added', result.data.theOrder)

         }catch(errors){
           this.inProgress = false;
           this.$toasted.show(errors.response.data.message, {
                      type: "error",
                      action: {
                        text: "Close",
                        class: "toastBtnTxt",
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0);
                        },
                      },
                      duration: 5000,
                    });
         }
       },
       showCantAddNotification(){
         this.$toasted.show('Order can\'t be added to Print Queue. Check order statuses.', {
                      type: "error",
                      action: {
                        text: "Close",
                        class: "toastBtnTxt",
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0);
                        },
                      },
                      duration: 5000,
                    });
       }
     },
     computed: {
       lastAddedDate(){
          if(this.itemInList && this.itemInList.length > 0){
             return this.itemInList[0].createdAt
          }else{
            return false;
          }
       }
     }
  }
</script>

<style lang="scss" scoped>
  .printQueueTriggerWrapper{
      position: absolute;
      right: -25px;
      top: 45px;
  }
  .addIt, .inactiveAddIt{
    width: 25px;
    color: #fff;
    text-align: center;
    border-radius: 0 3px 3px 0;
    cursor: pointer;

    .added{
      position: absolute;
      right: -45px;
      font-size: 12px;
      color: rgb(71, 187, 25);
    }

    &.alreadyExists{
      background-color: red !important;
    }
    .alreadyAdded{
      position: absolute;
      top: 20px;
      right:0;
      color: red;
      white-space: nowrap;
      visibility: hidden;
      transform: translate(40px, 0);
      opacity: 0;
      transition: all 500ms ease;
    }

    &:hover .alreadyAdded{
      visibility: visible;
      opacity: 1;
      transform: translate(0, 0);
    }
  }
  .inactiveAddIt{
     background-color: rgb(172, 172, 172);
  }
  .inProgress{
    position: absolute;
    right: -20px;
    top: 0;
  }
  .item-trigger{
    background-color: rgb(207, 206, 206);
  }
</style>